<template>
  <div class="common-bg" style="min-height: 100vh">
    <van-nav-bar title="" left-arrow @click-left="$router.back()" class="gamepage-nav-bar" />
    <div v-if="url" style="height: calc(100vh - 46px); overflow-y: scroll; -webkit-overflow-scrolling: touch">

      <iframe style="height: 100%; width: 100%"  ref="iframe" scrolling="auto" frameborder="0"  id="iframe"></iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: 'gamePage',
  data() {
    return {
      url: null,
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    // 打开代理
    console.log(query)
    if (query.dailiD == 1) {
      that.getAgentLoginUrl();
      return;
    }
    // 打开客服
    if (query.dailiD == 2) {
      that.getservicerurl();
      return;
    }
    if (query.app == 1) {
     that.url = that.$store.state.appInfo.ios_download_url;
      return;
    }
    if (query.name) {
      that.goGamePage(query.name, query.type, query.code);
    }
  },
  methods: {
    // 打开客服
    getservicerurl() {
      let that = this;
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
    // 打开代理
    getAgentLoginUrl() {
      let that = this;
      that.$apiFun.get('/api/getAgentLoginUrl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
    // 打开游戏
    goGamePage(name, type, code) {
      let that = this;

      that.$apiFun
        .post('/api/getGameUrl', { plat_name: name, game_type: type || 0, game_code: code, is_mobile_url: 1 })
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.url = res.data.url;
          }
        })
        .catch(res => {});
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
    that.$refs.iframe.contentWindow.location.replace(that.url);
  },
};
</script>

<style lang="scss" scoped>
// @import '../../../static/css/chunk-099d4415.690b75b1.css';
@import '../../../static/css/common.css';
</style>

<style lang="scss">
.gamepage-nav-bar.van-nav-bar,
.van-nav-bar.gamepage-nav-bar {
  background-color: #1e1f24 !important;
}
.gamepage-nav-bar.van-nav-bar .van-nav-bar__title,
.van-nav-bar.gamepage-nav-bar .van-nav-bar__title {
  color: #fff !important;
  font-size: 0.36rem !important;
  max-width: 70% !important;
}
.gamepage-nav-bar.van-nav-bar .van-icon,
.van-nav-bar.gamepage-nav-bar .van-icon,
.gamepage-nav-bar.van-nav-bar .van-nav-bar__arrow,
.van-nav-bar.gamepage-nav-bar .van-nav-bar__arrow,
.gamepage-nav-bar.van-nav-bar .van-nav-bar__text,
.van-nav-bar.gamepage-nav-bar .van-nav-bar__text {
  color: #fff !important;
}
.gamepage-nav-bar.van-hairline--bottom:after,
.van-nav-bar.gamepage-nav-bar.van-hairline--bottom:after {
  border-bottom-width: 0 !important;
  border: none !important;
  height: 0 !important;
}
.common-bg {
  background-color: #1e1f24 !important;
}
body .gamepage-nav-bar,
html .gamepage-nav-bar,
#app .gamepage-nav-bar {
  background-color: #1e1f24 !important;
}
body .gamepage-nav-bar .van-nav-bar__title,
html .gamepage-nav-bar .van-nav-bar__title,
#app .gamepage-nav-bar .van-nav-bar__title {
  color: #fff !important;
}
body .gamepage-nav-bar .van-nav-bar__arrow,
html .gamepage-nav-bar .van-nav-bar__arrow,
#app .gamepage-nav-bar .van-nav-bar__arrow,
body .gamepage-nav-bar .van-icon,
html .gamepage-nav-bar .van-icon,
#app .gamepage-nav-bar .van-icon {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/gamePage.vue